import { createConsumer } from "@rails/actioncable";
const cable = createConsumer("wss://mighty-sierra-66153.herokuapp.com/cable");

// const cable = createConsumer("http://localhost:3006/cable");



// const cable = createConsumer("http://localhost:3000/cable");

export default cable;
